import { ProForm } from "@ant-design/pro-components";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { CustomInput } from "../../../../components";
import { moneyFormat } from "../../../../plugins/numberFormat";
import styles from "./style.module.scss";
import "./style.scss";

const Calculator = ({ data }) => {
  const { t } = useTranslation();
  const formRef = useRef();
  const [valueEnum, setValueEnum] = useState({});
  const [rate, setRate] = useState("0");

  const setFieldRate = (amount, rate) => {
    formRef.current.setFieldValue("rate", moneyFormat(amount * Number(rate) * 0.01));
  };

  const handleChangeInput = (value) => {
    // console.debug(value);
    if (!value) {
      setFieldRate(0, 0);
    } else {
      setFieldRate(value, rate);
    }
  };

  const handleChangeContract = async (id) => {
    const target = data?.s.filter((item) => item.id === Number(id));
    if (!target || target.length <= 0) return;

    const newRate = moneyFormat((target[0].bonus / target[0].money) * 100);
    const currentAmount = formRef.current.getFieldValue("amount");
    setRate(newRate);
    setFieldRate(currentAmount, newRate);
  };

  useEffect(() => {
    if (!data) return;
    // console.debug("contractData", data?.s);
    let result = {};
    data?.s.map((item, index) => {
      result[item.id] = item.name;
      if (index === 0) {
        formRef.current.setFieldValue("contract", item.name);
        setRate(moneyFormat((item.bonus / item.money) * 100));
      }
      return {
        item,
      };
    });
    setValueEnum(result);
  }, [data]);

  return (
    <div className={styles.calculator}>
      <ProForm
        formRef={formRef}
        submitter={false}
        // className="recharge-from"
      >
        <CustomInput
          type="select"
          name="contract"
          label={t("nav.project")}
          valueEnum={valueEnum}
          onChange={handleChangeContract}
        />
        <CustomInput
          label={t("label.funds")}
          name="amount"
          placeholder={t("normal.pleaseEnter", { label: t("label.funds") })}
          type="number"
          onChange={handleChangeInput}
        />
        <div className={`${styles.inputContainer} calculator-rate-input`}>
          <CustomInput
            label={t("project.detail.totalIncome")}
            name="rate"
            initialValue={0.0}
            readOnly
            type="number"
          />
          <div className={styles.rate}>{t("home.calculator.rate", { rate })}</div>
        </div>
      </ProForm>
    </div>
  );
};

export default Calculator;
